<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-data-table :headers="headers" :items="food" :items-per-page="15" :loading="loading" :search="search" dense>
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Food</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="500px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on">New Food</v-btn>
                </template>
                <v-card :loading="isSaving">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-form v-model="valid" ref="foodForm">
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <v-text-field v-model="editedItem.n" label="Description" :rules="[rules.required]"></v-text-field>
                          </v-flex>
                          <v-flex xs8 sm4 md4>
                            <v-text-field v-model="editedItem.p" label="Portion Size" :rules="[rules.required, rules.isNumber]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm3 md3>
                            <v-text-field v-model="editedItem.u" label="Portion Unit" :rules="[rules.required]"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm5 md5>
                            <v-select :items="choices" label="Choice" v-model="editedItem.c" :rules="[rules.required]"></v-select>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Carbs" label="Carbs" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Milk" label="Milk" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Fruit" label="Fruit" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Fat" label="Fat" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Protein" label="Protein" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                          <v-flex xs4 sm2 md2>
                            <v-text-field v-model="editedItem.Veg" label="Veg" placeholder=" " @blur="resetValidation" :rules="[rules.portions]"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.p="{ item }">
            {{ item.p }} {{ item.u }}
          </template>
          <template v-slot:item.c="{ item }">
            <span :class="getChoiceColor(item.c)+'--text'">{{ getChoiceText(item.c) }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteConfirm(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>

        <v-dialog v-model="delDialog" max-width="290">
          <v-card :loading="isDeleteing">
            <v-card-title class="headline">Delete food?</v-card-title>
            <v-card-text>Are you sure you would like to delete '{{ editItem.n }}'?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="delDialog = false">No</v-btn>
              <v-btn color="error" text @click="deleteFood(editItem)">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import foodService from "../service/foodService";

export default {
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Food" : "Edit Food"; // + this.editedItem.description
    }
  },
  // watch: {
  //   options: {
  //     handler() {
  //       // this.getDataFromApi()
  //       //   .then(data => {
  //       //     this.desserts = data.items
  //       //     this.totalDesserts = data.total
  //       //   })
  //       // :options.sync="options"
  //       // :server-items-length="totalFood"
  //     },
  //     deep: true
  //   }
  // },
  data() {
    return {
      valid: false,
      choices: [ { text: 'Best', value: 1 }, { text: 'Better', value: 2 }, { text: 'Breakout', value: 3 }, { text: 'Good', value: 4 }],
      delDialog: false,
      dialog: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      options: {},
      totalFood: 0,
      loading: true,
      isSaving: false,
      isDeleteing: false,
      search: '',
      headers: [
        {
          text: "Description",
          align: "left",
          value: "n"
        },
        { text: "Portion", value: "p", align:"end" },
        { text: "Choice", value: "c", align:"center" },
        { text: "Carbs", value: "Carbs", align:"center" },
        { text: "Milk", value: "Milk", align:"center" },
        { text: "Fruit", value: "Fruit", align:"center" },
        { text: "Fat", value: "Fat", align:"center" },
        { text: "Protein", value: "Protein", align:"center" },
        { text: "Veg", value: "Veg", align:"center" },
        { text: "Actions", value: "action", sortable: false }
      ],
      food: [],
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        isNumber: value => !isNaN(value) || 'Only numbers allowed.',
        portions: v => (
          (!!this.editedItem.Carbs && !isNaN(this.editedItem.Carbs))
          || (!!this.editedItem.Milk && !isNaN(this.editedItem.Milk)) 
          || (!!this.editedItem.Fruit && !isNaN(this.editedItem.Fruit)) 
          || (!!this.editedItem.Fat && !isNaN(this.editedItem.Fat)) 
          || (!!this.editedItem.Veg && !isNaN(this.editedItem.Veg)) 
          || (!!this.editedItem.Protein && !isNaN(this.editedItem.Protein))) || 'At least one required. Must be a number.',
      }
    };
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.food.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteConfirm(item) {
      this.editedItem = Object.assign({}, item);
      this.delDialog = true;
    },
    deleteFood(food) {    
      this.isDeleting = true;  
      foodService.deleteFood(this.editedItem.id)
        .then(() => {
          this.close();
          this.delDialog = false;
          this.isDeleting = false
          this.loadFood();
        })
        .catch(error => (this.isDeleteing = false));
    },
    save() {
      if (this.$refs.foodForm.validate())
      {
        this.isSaving = true;
        // Add or edit?
        let func = foodService.addFood;
        if (this.editedIndex > -1) {
          func = foodService.updateFood;
        }
        // Now run the function
        func(this.editedItem)
          .then(food => {
            this.isSaving = false;
            this.close();
            this.loadFood();
          })
          .catch(error => (this.isSaving = false));
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    loadFood() {
      foodService.getFood().then(fd => {
        console.log('loading fd', fd)
        this.food = fd;
        this.loading = false;
      });
    },
    getChoiceColor (choice) {
      if (choice == 4) return 'red'
      else if (choice == 3 || choice == 2) return 'orange'
      else if (choice == 1) return 'green'
    },
    getChoiceText (choiceVal) {
      let choice = this.choices.find(c => c.value == choiceVal);
      console.log(choiceVal);
      return (choice) ? choice.text : 'Not Set'
    },
    resetValidation() {
      this.$refs.foodForm.validate();
    }
  },
  mounted() {
    this.loadFood();
  }
};
</script>

<style>
</style>
